import {myEnrollmentsApi} from '@/api/my-enrollments.api.js'
import {addressTypes} from '@/constants/address-types.js'
import {useQuerying} from '@/composables/use-querying.js'
import {useTeams} from '@/composables/use-teams.js'

/**
 * Helper composable for enrollments querying
 */
export function useEnrollmentsQuerying() {

  //Check if in Teams
  const {isInTeams} = useTeams()

  //Enrollment querying
  const {
    items: enrollments,
    queryItems: queryEnrollments,
    loadItems: loadEnrollments,
    loadMoreItems: loadMoreEnrollments,
    isLoadingItems: isLoadingEnrollments,
    isLoadingMoreItems: isLoadingMoreEnrollments,
    hasLoadedAllItems: hasLoadedAllEnrollments,
    sort,
    search,
    changeSort,
    changeSearch,
    changeFilter,
  } = useQuerying({
    handler: params => myEnrollmentsApi.query(params),
    sort: '-lastMessageSentAt',
    limit: 10,
    filter: {
      provider: isInTeams.value ? addressTypes.TEAMS : undefined,
      isRecent: true,
    },
  })

  //Expose interface
  return {
    enrollments,
    queryEnrollments,
    loadEnrollments,
    loadMoreEnrollments,
    isLoadingEnrollments,
    isLoadingMoreEnrollments,
    hasLoadedAllEnrollments,
    sort,
    search,
    changeSort,
    changeSearch,
    changeFilter,
  }
}
